import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    flex: 1,
  },
  dayCircle: {
    aspectRatio: 1,
    flex: 1,
    borderRadius: theme.borderRadius.full,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.backgroundPrimaryInverse,
    overflow: 'hidden',
    variants: {
      fill: {
        available: {
          backgroundColor: colors.backgroundPrimaryInverse,
        },
        // SQR-14330: a day with no open slots but a live waitlist is still
        // actionable, so it renders exactly like an available day (WoM parity).
        waitlistOnly: {
          backgroundColor: colors.backgroundPrimaryInverse,
        },
        disabled: {
          backgroundColor: colors.backgroundL2,
        },
      },
    },
  },
  dayNumber: {
    color: colors.textPrimaryInverse,
    variants: {
      fill: {
        available: {
          color: colors.textPrimaryInverse,
        },
        waitlistOnly: {
          color: colors.textPrimaryInverse,
        },
        disabled: {
          color: colors.textSecondary,
        },
      },
    },
  },
  indicatorRing: {
    padding: 2,
    borderWidth: 1,
    aspectRatio: 1,
    flex: 1,
    maxWidth: {
      base: undefined,
      tablet: 52,
    },
    borderRadius: theme.borderRadius.full,
    borderColor: 'transparent',
    variants: {
      selected: {
        true: {
          borderColor: colors.textPrimary,
        },
      },
    },
  },
  todayIndicator: {
    position: 'absolute',
    bottom: theme.spacing[2],
    alignSelf: 'center',
    width: 4,
    height: 4,
    borderRadius: theme.borderRadius.full,
    backgroundColor: colors.backgroundPrimary,
    variants: {
      fill: {
        available: {
          backgroundColor: colors.backgroundPrimary,
        },
        waitlistOnly: {
          backgroundColor: colors.backgroundPrimary,
        },
        disabled: {
          backgroundColor: colors.textSecondary,
        },
      },
    },
  },
}));
